import { Base } from './Base';

export class Faq extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);
    this.minVisibleSections = 0;
    this.visibleSections = 0;
    this.totalSections = 0;
    this.sections = null;
    this.seeAll = null;
    this.init();
  }

  init() {
    const { visibleSections, totalSections } = this.element.dataset;
    this.totalSections = totalSections;
    this.visibleSections = visibleSections;
    this.minVisibleSections = visibleSections;
    this.seeAll = document.getElementById('faq-see-all');
    this.sections = document.getElementById('faq-sections');
    this.updateSectionsList();
    //
    const children = this.sections.children;
    for (var i = 0; i < children.length; i++) {
      const section = children[i];
      const questions = section.getElementsByTagName('li')
      for (var q = 0; q < questions.length; q++) {
          const question = questions[q];
          question.addEventListener("click", (e) => {
            this.toggleQuestion(questions, question);
          });
      }
    }
    //
    this.seeAll.addEventListener("click", (e) => {
      e.preventDefault();
      this.toggleSections();
    });
  }

  toggleQuestion(questions, target){ 
    for (var q = 0; q < questions.length; q++) {
      const question = questions[q];
      if(question != target) { 
        question.classList.remove("active");
      }
    }
    //
    if(target.classList.contains('active')) {
      target.classList.remove("active");
    } else {
      target.classList.add("active");
    }
  }

  toggleSections() {
    if(this.visibleSections < this.totalSections) {
      this.visibleSections = this.totalSections;
    } else {
      this.visibleSections = this.minVisibleSections;
    }
    this.updateSectionsList();
  }

  updateSectionsList() {
    if(this.visibleSections < this.totalSections) {
      this.seeAll.classList.add("display");
    } else {
      this.seeAll.classList.remove("display");
    }
    const children = this.sections.children;
    for (var i = 0; i < children.length; i++) {
      const section = children[i];
      if((i+1) <= this.visibleSections  ) {
        section.classList.add("display");
      }
    }

  }
  
}